/**
 * Bootstrap Module Index
 *
 * Re-exports the entry heuristic the client imports through here.
 */

export { inferDefaultEntryNodeId } from "./entry-heuristics";
